import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: '/api',
  timeout: 0
})

service.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      if (res.code === 401 || res.code === 403) {
        localStorage.removeItem('token')
        router.push('/login')
      }
      return Promise.reject(new Error(res.message))
    }
    return res
  },
  error => {
    if (error.response) {
      const data = error.response.data
      const msg = (data && data.message) || error.message
      if (error.response.status === 401) {
        localStorage.removeItem('token')
        router.push('/login')
        Message.error('登录已过期，请重新登录')
      } else if (error.response.status === 403) {
        localStorage.removeItem('token')
        router.push('/login')
        Message.error(msg || '无权限访问')
      } else {
        Message.error(msg || '服务器内部错误')
      }
    } else {
      Message.error('网络连接失败')
    }
    return Promise.reject(error)
  }
)

export default {
  login(data) { return service.post('/auth/login', data) },
  register(data) { return service.post('/auth/register', data) },
  getUserInfo() { return service.get('/auth/userInfo') },

  createUser(data) { return service.post('/user/create', data) },
  getSubUsers() { return service.get('/user/subUsers') },
  getAllUsers() { return service.get('/user/all') },
  getUserTree() { return service.get('/user/tree') },
  getParentCandidates() { return service.get('/user/parentCandidates') },
  updateUserStatus(userId, status) { return service.put('/user/status/' + userId + '?status=' + status) },
  updateUser(userId, data) { return service.put('/user/' + userId, data) },
  deleteUser(userId) { return service.delete('/user/' + userId) },
  changePassword(data) { return service.put('/user/changePassword', data) },

  importExcel(formData) { return service.post('/data/import', formData, { headers: { 'Content-Type': 'multipart/form-data' } }) },
  queryData(data) { return service.post('/data/query', data) },
  queryDataAll(data) { return service.post('/data/queryAll', data) },
  getGroupStats(data) { return service.post('/data/groupStats', data) },
  getVideoOwners(videoId) { return service.get('/data/videoOwners', { params: { videoId } }) },
  getSummaryStats(data) { return service.post('/data/summary', data) },
  getDataByVideoId(videoId) { return service.get('/data/video/' + videoId) },
  getDistinctVideos() { return service.get('/data/distinctVideos') },
  deleteDataRecord(id) { return service.delete('/data/delete/' + id) },
  deleteDataRecordBatch(ids) { return service.delete('/data/delete/batch', { data: ids }) },
  getImportLogs() { return service.get('/data/importLogs') },

  getAllVideos() { return service.get('/video/all') },
  getVideo(videoId) { return service.get('/video/' + videoId) },
  saveVideo(data) { return service.post('/video/save', data) },
  deleteVideo(id) { return service.delete('/video/' + id) },

  setCommission(data) { return service.post('/commission/set', data) },
  batchSetCommission(data) { return service.post('/commission/batchSet', data) },
  getCommissionList() { return service.get('/commission/list') },
  deleteCommission(id) { return service.delete('/commission/' + id) },

  theaterList() { return service.get('/theater/list') },
  theaterAll() { return service.get('/theater/all') },
  theaterAdd(data) { return service.post('/theater/add', data) },
  theaterUpdate(data) { return service.put('/theater/update', data) },
  theaterDelete(id) { return service.delete('/theater/' + id) },

  teamList() { return service.get('/team/list') },
  teamCreate(data) { return service.post('/team/create', data) },
  teamUpdate(data) { return service.put('/team/update', data) },
  teamDelete(id) { return service.delete('/team/' + id) },
  teamImport(formData) { return service.post('/team/import', formData, { headers: { 'Content-Type': 'multipart/form-data' } }) },

  bindVideo(data) { return service.post('/user/bindVideo', data) },
  unbindVideo(videoId) { return service.delete('/user/bindVideo', { params: { videoId } }) },
  getUserRevenue(userId) { return service.get('/data/userRevenue/' + userId) },

  getInviteCode() { return service.get('/user/invite-code') },
  getInviteInfo(code) { return service.get('/auth/invite-info?code=' + code) },
  queryUserData(userId, params) { return service.get('/data/userData/' + userId, { params }) },
  queryUserDataAll(userId) { return service.get('/data/userDataAll/' + userId) }
}
